<template>
  <div class="app-navigation">
    <menu-button
      :icon="'icons/home.svg'"
      @click="handleHomeButton"
    />
    <menu-button
      v-for="navButton in navigationButtons"
      :key="navButton.id"
      :icon="navButton.icon"
      @click="$emit('navigate-button', navButton.next)"
      class="navigation-button"
    />

    <div
      v-if="contentLanguages.length === 2 && showLanguageSwitch"
      class="language-icon"
    >
      <menu-button
        :icon="`icons/flags/${secLang.code}.png`"
        @click="handleSelectSecLang"
      />
    </div>
    <div
      v-else-if="contentLanguages.length > 2 && showLanguageSwitch"
      class="language-icon"
    >
      <menu-button
        :icon="'icons/globe.png'"
        @click="$emit('show-menu')"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import MenuButton from '@/components/MenuButton.vue';
import useContent from '@/composables/useContent';
import useConfig from '@/composables/useConfig';

export default defineComponent({
  name: 'AppNavigationComponent',

  emits: ['navigate-button', 'show-menu', 'select-language', 'restart-flow'],

  components: {
    MenuButton,
  },

  setup(props, { emit }) {
    const { currentContent } = useContent();
    const {
      initialConfig,
      currentLanguage,
      showLanguageSwitch,
      setFlowStateHomeButton,
      setFlowStateUserLanguageSwitch,
    } = useConfig();

    const contentLanguages = computed(() => initialConfig.value.contentLanguages.filter((lang) => lang.active));
    const secLang = computed(() => contentLanguages.value.find((l) => l.code !== currentLanguage.value));

    const navigationButtons = computed(() => {
      const buttons = [];
      if (currentContent.value?.attrs?.backButton) {
        buttons.push({
          id: 'back',
          icon: 'icons/back.svg',
          next: currentContent.value.attrs.backButton,
        });
      }

      if (currentContent.value?.attrs?.repeatButton) {
        buttons.push({
          id: 'repeat',
          icon: 'icons/repeat.svg',
          next: currentContent.value.attrs.repeatButton,
        });
      }

      if (currentContent.value?.attrs?.forwardButton) {
        buttons.push({
          id: 'forward',
          icon: 'icons/forward.svg',
          next: currentContent.value.attrs.forwardButton,
        });
      }

      return buttons;
    });

    function handleSelectSecLang() {
      setFlowStateUserLanguageSwitch();
      emit('select-language', secLang.value.code);
      emit('restart-flow');
    }

    function handleHomeButton() {
      setFlowStateHomeButton();
      emit('restart-flow');
    }

    return {
      contentLanguages,
      secLang,
      navigationButtons,
      showLanguageSwitch,
      handleSelectSecLang,
      handleHomeButton,
    };
  },
});
</script>

<style lang="scss" scoped>
.app-navigation {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  position: relative;
}
</style>
